import {PatientDrawer} from '@/modules/patients/components/patient-drawer/patient-drawer'
import {PatientProvider} from '@/shared/contexts/patient-context'
import {Patient} from '@cypro/engine/schema'
import {drawer} from '@cypro/ui/components'
import {Suspense} from 'react'

export function getPatientDrawerId(patientId: string) {
  return `patient-drawer-${patientId}`
}

export function openPatientDrawer(patient: Patient) {
  const id = getPatientDrawerId(patient.id)

  try {
    drawer.remove(id)
  } catch {}

  return drawer.open(id, {
    id,
    children: (
      <Suspense fallback={null}>
        {patient && (
          <PatientProvider patient={patient}>
            <PatientDrawer />
          </PatientProvider>
        )}
      </Suspense>
    ),
    contentProps: {
      'data-e2e': 'patient-drawer',
    },
  })
}
